import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import Component from "@reactions/component";
import KeyboardBackspace from '@material-ui/icons/KeyboardBackspace';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Pane, Dialog, Spinner, SideSheet, Position, SelectField } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Row, Col, Card, ListGroup, Button, Container, Form, Table, ButtonGroup, Alert, Badge } from 'react-bootstrap';
import MaterialDatatable from "material-datatable";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Logo from '../../assets/img/printlogo.jpg';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { Link } from 'react-router-dom';
import Login from '../common/login';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import * as moment from "moment-timezone";
import 'react-toastify/dist/ReactToastify.css';

// Icons
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import BatteryChargingFullIcon from '@material-ui/icons/BatteryChargingFull';
import BuildIcon from '@material-ui/icons/Build';
import SpeedIcon from '@material-ui/icons/Speed';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import EventIcon from '@material-ui/icons/Event';
import StoreIcon from '@material-ui/icons/Store';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import CancelIcon from '@material-ui/icons/Cancel';

const cookies = new Cookies();
const role = Number(localStorage.getItem('role'))

// Modern Light Theme with Vibrant Colors
const styles = {
    mainContainer: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        paddingBottom: '3rem',
        fontFamily: "'Tajawal', sans-serif",
        direction: 'rtl'
    },
    navBar: {
        background: '#ffffff',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
        padding: '1.5rem 0',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        marginBottom: '3rem'
    },
    backButtonContainer: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem'
    },
    backButton: {
        color: '#5e72e4',
        fontSize: 32,
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        padding: '8px 16px',
        borderRadius: '12px',
        '&:hover': {
            background: 'rgba(94, 114, 228, 0.1)',
            transform: 'translateX(5px)'
        }
    },
    headerCard: {
        background: 'linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)',
        borderRadius: '20px',
        padding: '3rem 2rem',
        marginBottom: '3rem',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 20px 40px rgba(94, 114, 228, 0.3)'
    },
    headerPattern: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
        transform: 'translate(50%, -50%)'
    },
    mainTitle: {
        fontSize: '2.5rem',
        color: '#ffffff',
        fontWeight: '800',
        textAlign: 'center',
        marginBottom: '0.5rem',
        position: 'relative',
        zIndex: 1
    },
    subtitle: {
        color: 'rgba(255,255,255,0.9)',
        textAlign: 'center',
        fontSize: '1.1rem',
        position: 'relative',
        zIndex: 1
    },
    infoSection: {
        background: '#ffffff',
        borderRadius: '20px',
        padding: '2.5rem',
        marginBottom: '2rem',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
    },
    infoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '1.5rem'
    },
    infoCard: {
        background: '#f8f9fe',
        borderRadius: '16px',
        padding: '1.8rem',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        border: '1px solid #e3e8f7',
        '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 15px 30px rgba(0,0,0,0.1)',
            borderColor: '#5e72e4'
        }
    },
    infoIcon: {
        position: 'absolute',
        top: '1.5rem',
        right: '1.5rem',
        fontSize: '2rem',
        opacity: 0.15
    },
    infoContent: {
        textAlign: 'right'
    },
    infoLabel: {
        color: '#8898aa',
        fontSize: '0.85rem',
        fontWeight: '600',
        marginBottom: '0.5rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    infoValue: {
        color: '#32325d',
        fontSize: '1.3rem',
        fontWeight: '700'
    },
    statusBadge: {
        display: 'inline-block',
        padding: '0.5rem 1.8rem',
        borderRadius: '50px',
        fontSize: '0.9rem',
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },
    tableSection: {
        background: '#ffffff',
        borderRadius: '20px',
        padding: '2rem',
        marginBottom: '2rem',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
        direction: 'ltr'
    },
    modernTable: {
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
        direction: 'ltr'
    },
    tableHeader: {
        background: 'linear-gradient(135deg, #f6f9fc 0%, #e9ecef 100%)',
        color: '#32325d',
        fontWeight: '700',
        padding: '1rem',
        borderBottom: '2px solid #e3e8f7',
        textAlign: 'center',
        fontSize: '0.9rem',
        letterSpacing: '0.5px'
    },
    tableCell: {
        padding: '1.2rem',
        borderBottom: '1px solid #e9ecef',
        color: '#525f7f',
        textAlign: 'center',
        fontSize: '0.95rem'
    },
    tableRow: {
        background: '#ffffff',
        transition: 'all 0.3s ease',
        '&:hover': {
            background: '#f6f9fc',
            transform: 'scale(1.01)'
        }
    },
    summaryCards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1.5rem',
        marginTop: '3rem'
    },
    summaryCard: {
        background: '#ffffff',
        borderRadius: '16px',
        padding: '2rem',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
        borderRight: '4px solid',
        '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.12)'
        }
    },
    summaryIconBg: {
        position: 'absolute',
        top: '50%',
        right: '20px',
        transform: 'translateY(-50%)',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.1
    },
    summaryContent: {
        marginLeft: '60px',
        textAlign: 'right'
    },
    summaryLabel: {
        color: '#525f7f',
        fontSize: '0.95rem',
        fontWeight: '600',
        marginBottom: '0.8rem'
    },
    summaryValue: {
        fontSize: '2rem',
        fontWeight: '800',
        lineHeight: '1'
    },
    statsSection: {
        marginTop: '4rem',
        marginBottom: '3rem'
    },
    statsHeader: {
        textAlign: 'center',
        marginBottom: '3rem'
    },
    statsTitle: {
        fontSize: '2.5rem',
        color: '#32325d',
        fontWeight: '800',
        marginBottom: '0.5rem'
    },
    statsSubtitle: {
        color: '#8898aa',
        fontSize: '1.1rem'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '2rem',
        marginBottom: '3rem'
    },
    statCard: {
        background: '#ffffff',
        borderRadius: '24px',
        padding: '2.5rem',
        textAlign: 'center',
        position: 'relative',
        overflow: 'visible',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
        border: '2px solid transparent',
        '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 20px 50px rgba(0,0,0,0.15)'
        }
    },
    statIconWrapper: {
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 1.5rem',
        position: 'relative'
    },
    statIcon: {
        fontSize: '3rem',
        color: '#ffffff',
        zIndex: 1
    },
    statLabel: {
        color: '#525f7f',
        fontSize: '1.1rem',
        fontWeight: '600',
        marginBottom: '1rem',
        lineHeight: '1.4'
    },
    statValue: {
        fontSize: '3rem',
        fontWeight: '800',
        marginBottom: '0.5rem',
        lineHeight: '1'
    },
    statUnit: {
        fontSize: '1.2rem',
        fontWeight: '600',
        opacity: 0.8
    },
    statChange: {
        fontSize: '0.9rem',
        fontWeight: '600',
        marginTop: '0.5rem',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.3rem',
        padding: '0.3rem 0.8rem',
        borderRadius: '20px'
    },
    actionButtons: {
        display: 'flex',
        justifyContent: 'center',
        gap: '1rem',
        flexWrap: 'wrap',
        marginTop: '2rem'
    },
    actionButton: {
        padding: '1rem 3rem',
        borderRadius: '50px',
        fontSize: '1rem',
        fontWeight: '700',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
        '&:hover': {
            transform: 'translateY(-3px)',
            boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
        }
    },
    primaryButton: {
        background: 'linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)',
        color: '#ffffff'
    },
    successButton: {
        background: 'linear-gradient(135deg, #2dce89 0%, #11cdef 100%)',
        color: '#ffffff'
    },
    dangerButton: {
        background: 'linear-gradient(135deg, #f5365c 0%, #f56036 100%)',
        color: '#ffffff'
    },
    warningButton: {
        background: 'linear-gradient(135deg, #fb6340 0%, #fbb140 100%)',
        color: '#ffffff'
    },
    checkboxContainer: {
        background: '#f8f9fe',
        borderRadius: '12px',
        padding: '1rem 1.5rem',
        marginTop: '1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
    }
};

const columns = [
    { field: "parts_costs", name: "تكلفة قطع الغيار", options: { filter: false, sort: true, } },
    { field: "softCost", name: "تكلفة السوفت", options: { filter: false, sort: true, } },
    { field: "battery", name: "نسبة البطارية", options: { filter: false, sort: true, } },
    { field: "paybass", name: "تخطي", options: { filter: true, sort: true, } },
    { field: "status", name: "الحالة", options: { filter: true, sort: true, } },
    { field: "item_out", name: "اسم النهائي", options: { filter: true, sort: true, } },
    { field: "item_in", name: "اسم الاولي", options: { filter: true, sort: true, } },
    { field: "id", name: "#", options: { filter: false, sort: true, } },
];

const options = {
    selectableRows: false,
    responsive: 'scroll',
    rowCursorHand: false,
    sort: true,
    print: false,
    filter: true,
    rowsPerPage: 1001,
    download: false,
    textLabels: {
        body: {
            noMatch: " لم يتم العثور على سجلات مطابقة",
            toolTip: "فرز",
        },
        pagination: {
            next: "الصفحة التالية",
            previous: "الصفحة السابقة",
            rowsPerPage: "عدد الصفوف",
            displayRows: "من",
        },
        toolbar: {
            search: "بحث",
            downloadCsv: "تنزيل",
            print: "Print",
            viewColumns: " التحكم بالاعمدة",
            filterTable: "فلتر",
        },
        filter: {
            all: "الكل",
            title: "فلتر",
            reset: "إعادة تعيين",
        },
        viewColumns: {
            title: "عرض الأعمدة",
            titleAria: "إظهار / إخفاء أعمدة الجدول",
        },
    }
}

class Category extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nameCate: '',
            image: [],
            Category: [],
            spin: false,
            name: '',
            sn: '',
            notes: '',
            battery: "",
            id: "",
            itemsCount: 1,
            suppliers: [],
            items: [],
            t_price: 0,
            sup_id: "",
            type: "",
            "paid_amount": '',
            "r_amount": '',
            "payed": '',
            "status": '',
            "shipping": '',
            "add_at": '',
            "supplierName": '',
            Getid: "",
            msg: "",
            is_transfer: false,
            safeCheck: false,
            items_sana: [],
            "parts_cost": 0,
            "softCost": 0,
            "battery_avg": 0,
            "paybass": 4,
            inItems: [],
        }

        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        this.setState({ Getid: Getid })
    }

    getMuiTheme = () => createMuiTheme({
        palette: {
            primary: {
                main: '#5e72e4',
            },
            secondary: {
                main: '#11cdef',
            }
        },
        overrides: {
            MaterialDatatableBodyCell: {
                root: {
                    textAlign: 'center',
                    padding: '16px'
                },
            },
            MuiTableCell: {
                root: {
                    textAlign: 'center',
                },
                head: {
                    background: 'linear-gradient(135deg, #f6f9fc 0%, #e9ecef 100%)',
                    color: '#32325d !important',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                }
            },
            MuiPaper: {
                elevation4: {
                    borderRadius: '16px',
                    boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                    overflow: 'hidden'
                }
            }
        }
    })

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let bill_itmes = []
        let sana_items = []
        let Getid = urlParams.get('id')
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        
        axios.get(host + `dashbord/bill/get/${Getid}`, { headers: header })
            .then(res => {
                let arry = []
                let msg = ""
                if (res.data.bills.status == 0) {
                    msg = 'غير مدققة'
                } else if (res.data.bills.status == 1) {
                    msg = 'انتظار'
                } else if (res.data.bills.status == 2) {
                    msg = 'تم الادخال الى المخزن'
                } else if (res.data.bills.status == 3) {
                    msg = 'ملغية'
                }

                bill_itmes = res.data.bills.item
                this.setState({
                    items: res.data.bills.item,
                    t_price: res.data.bills.t_amount,
                    is_transfer: res.data.bills.is_transfer,
                    "paid_amount": res.data.bills.paid_amount,
                    "r_amount": res.data.bills.r_amount,
                    "type": res.data.bills.type,
                    "payed": res.data.bills.payed,
                    "status": res.data.bills.status,
                    "shipping": res.data.bills.shipping,
                    "notes": res.data.bills.notes,
                    safeCheck: res.data.bills.safeCheck,
                    "add_at": res.data.bills.add_at,
                    "supplierName": res.data.bills.suppliers.name,
                    msg
                });
            })
            .catch(error => { console.log(error.response) })

        axios.get(host + `dashbord/sana/bill/reports/${Getid}`, { headers: header })
            .then(res => {
                let arry = []
                let items = res.data.items;
                for (let index = 0; index < items.length; index++) {
                    sana_items = res.data.items.inItems
                    let status = {
                        "-1": "معلق في الصيانة",
                        "0": "سوفت",
                        "1": "فحص",
                        "2": "جاهز للمخزن",
                        "3": "في المخزن",
                        "5": "معلق في السوفت ",
                        "6": "تم بيع الجهاز",
                        '4': "ملغي"
                    }
                    let payypass = "كلا"
                    if (items[index].paybass) {
                        payypass = "نعم"
                    }
                    let obj = {
                        "id": items[index].id,
                        "dw_price": items[index].dw_price,
                        "parts_costs": items[index].parts_costs,
                        "softCost": items[index].softCost,
                        "battery": items[index].battery,
                        "paybass": payypass,
                        "status": status[items[index].status],
                        "item_in": items[index].item_in,
                        "item_in_id": items[index].item_in_id,
                        "item_out": items[index].item_out,
                        "item_out_id": items[index].item_out_id
                    }
                    arry.push(obj)
                }
                this.setState({
                    items_sana: arry,
                    "parts_cost": res.data.parts_cost,
                    "softCost": res.data.softCost,
                    "battery_avg": res.data.battery_avg,
                    "paybass": res.data.paybass,
                    inItems: res.data.inItems,
                })
            })
            .catch(error => { console.log(error.response) })
    }

    edit_shipping_price(id, price) {
        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        var header = { "Content-Type": "application/x-www-form-urlencoded", Authorization: cookies.get("tokenUser") };
        axios.post(host + `dashbord/bill/shpinng/edit/${Getid}`, {
            "prcie": price,
        })
            .then(response => {
                window.location.reload();
            })
            .catch(error => {});
    }

    chage_status(status) {
        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        var header = { "Content-Type": "application/x-www-form-urlencoded", Authorization: cookies.get("tokenUser") };
        axios.post(host + `dashbord/bill/shpinng/status/${Getid}`, {
            "status": status,
        })
            .then(response => {
                window.location.reload();
            })
            .catch(error => {});
    }

    get_inv(id) {
        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        let safeOut = document.getElementById('safeOut').checked;
        var header = { "Content-Type": "application/x-www-form-urlencoded", Authorization: cookies.get("tokenUser") };
        axios.post(host + `dashbord/bill/shpinng/in/${Getid}`, {
            "safeOut": safeOut,
        })
            .then(response => {
                window.location.reload();
            })
            .catch(error => {});
    }

    getStatusStyle(status) {
        const statusStyles = {
            0: { background: '#ffe5b4', color: '#ff8800' }, // غير مدققة
            1: { background: '#e3f2fd', color: '#2196f3' }, // انتظار
            2: { background: '#e8f5e9', color: '#4caf50' }, // تم الادخال
            3: { background: '#ffebee', color: '#f44336' }, // ملغية
        };
        return statusStyles[status] || { background: '#f5f5f5', color: '#757575' };
    }

    render() {
        let data = []
        let all_count = 0;
        let done_count = 0
        for (let index = 0; index < this.state.items.length; index++) {
            let item_id = this.state.items[index].item_id
            let obj = this.state.items[index]
            all_count = all_count + obj.count;

            if (this.state.inItems[item_id]) {
                obj.done = this.state.inItems[item_id].count
                obj.rem = obj.count - this.state.inItems[item_id].count
                done_count = this.state.inItems[item_id].count + done_count
            } else {
                obj.done = 0
                obj.rem = obj.count
            }
            data.push(obj)
        }

        if (cookies.get("token")) {
            return (
                <div style={styles.mainContainer}>
                    <ToastContainer />
                    
                    <div style={styles.navBar}>
                        <div style={styles.backButtonContainer}>
                            <Link to={`billsList`} style={{ textDecoration: 'none' }}>
                                <div style={styles.backButton}>
                                    <span style={{ fontSize: '1.1rem', fontWeight: '600' }}>العودة</span>
                                    <KeyboardBackspace style={{ fontSize: 'inherit', marginRight: '0.5rem', transform: 'rotate(180deg)' }} />
                                </div>
                            </Link>
                        </div>
                    </div>

                    <Container>
                        <div style={styles.headerCard}>
                            <div style={styles.headerPattern}></div>
                            <h1 style={styles.mainTitle}>فاتورة الموبايلات</h1>
                            <p style={styles.subtitle}>رقم الفاتورة: #{this.state.Getid}</p>
                        </div>

                        <div style={styles.infoSection}>
                            <div style={styles.infoGrid}>
                                <div style={styles.infoCard}>
                                    <StoreIcon style={{...styles.infoIcon, color: '#5e72e4'}} />
                                    <div style={styles.infoContent}>
                                        <div style={styles.infoLabel}>اسم التاجر</div>
                                        <div style={styles.infoValue}>{this.state.supplierName}</div>
                                    </div>
                                </div>
                                
                                <div style={styles.infoCard}>
                                    <EventIcon style={{...styles.infoIcon, color: '#11cdef'}} />
                                    <div style={styles.infoContent}>
                                        <div style={styles.infoLabel}>تاريخ القائمة</div>
                                        <div style={styles.infoValue}>{moment(this.state.add_at).format('DD/MM/YYYY')}</div>
                                    </div>
                                </div>
                                
                                <div style={styles.infoCard}>
                                    <LocalShippingIcon style={{...styles.infoIcon, color: '#fb6340'}} />
                                    <div style={styles.infoContent}>
                                        <div style={styles.infoLabel}>سعر التوصيل</div>
                                        <div style={styles.infoValue}>{this.state.shipping} دينار</div>
                                        {this.state.type == 1 && (this.state.status != 2 && this.state.status != 3) && (
                                            <Component initialState={{ isShown: false }}>
                                                {({ state, setState }) => (
                                                    <React.Fragment>
                                                        <SideSheet
                                                            isShown={state.isShown}
                                                            position={Position.LEFT}
                                                            onCloseComplete={() => setState({ isShown: false })}
                                                        >
                                                            <Container>
                                                                <br />
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>سعر التوصيل</Form.Label>
                                                                            <Form.Control 
                                                                                type="text" 
                                                                                style={{ textAlign: 'center' }} 
                                                                                id="editshp" 
                                                                            />
                                                                        </Form.Group>
                                                                        <center>
                                                                            <Button 
                                                                                variant="primary"
                                                                                onClick={() => {
                                                                                    let price = document.getElementById("editshp").value;
                                                                                    this.edit_shipping_price(this.state.Getid, price)
                                                                                }}
                                                                            >
                                                                                تعديل
                                                                            </Button>
                                                                        </center>
                                                                    </Col>
                                                                </Row>
                                                            </Container>
                                                        </SideSheet>
                                                        <button
                                                            style={{...styles.actionButton, ...styles.warningButton, marginTop: '1rem', fontSize: '0.9rem', padding: '0.5rem 1.5rem'}} 
                                                            onClick={() => setState({ isShown: true })}
                                                        >
                                                            تعديل
                                                        </button>
                                                    </React.Fragment>
                                                )}
                                            </Component>
                                        )}
                                    </div>
                                </div>
                                
                                <div style={styles.infoCard}>
                                    <ReceiptIcon style={{...styles.infoIcon, color: '#2dce89'}} />
                                    <div style={styles.infoContent}>
                                        <div style={styles.infoLabel}>نوع النقل</div>
                                        <div style={styles.infoValue}>
                                            {this.state.type == 0 ? 'داخلي' : 'خارجي'}
                                        </div>
                                    </div>
                                </div>
                                
                                <div style={styles.infoCard}>
                                    <AssignmentIcon style={{...styles.infoIcon, color: '#825ee4'}} />
                                    <div style={styles.infoContent}>
                                        <div style={styles.infoLabel}>الحالة</div>
                                        <div style={{...styles.statusBadge, ...this.getStatusStyle(this.state.status)}}>
                                            {this.state.msg}
                                        </div>
                                    </div>
                                </div>
                                
                                <div style={styles.infoCard}>
                                    <EditIcon style={{...styles.infoIcon, color: '#f5365c'}} />
                                    <div style={styles.infoContent}>
                                        <div style={styles.infoLabel}>ملاحظات</div>
                                        <div style={styles.infoValue}>{this.state.notes || 'لا توجد ملاحظات'}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={styles.tableSection}>
                            <h3 style={{ textAlign: 'center', marginBottom: '2rem', color: '#32325d', direction: 'rtl' }}>تفاصيل المنتجات</h3>
                            <Table style={styles.modernTable}>
                                <thead>
                                    <tr>
                                        <th style={styles.tableHeader}>السعر الكلي</th>
                                        <th style={styles.tableHeader}>سعر القطعة</th>
                                        <th style={styles.tableHeader}>لم يفحص</th>
                                        <th style={styles.tableHeader}>قيد الفحص</th>
                                        <th style={styles.tableHeader}>العدد</th>
                                        <th style={styles.tableHeader}>المنتج</th>
                                        <th style={styles.tableHeader}>ID</th>
                                        <th style={styles.tableHeader}>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, i) =>
                                        <tr key={i} style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>{(item.price * item.count).toFixed(2)}</strong></td>
                                            <td style={styles.tableCell}>{item.price.toFixed(2)}</td>
                                            <td style={styles.tableCell}>{item.rem}</td>
                                            <td style={styles.tableCell}>{item.done}</td>
                                            <td style={styles.tableCell}>{item.count}</td>
                                            <td style={styles.tableCell}>{item.name}</td>
                                            <td style={styles.tableCell}>{item.id}</td>
                                            <td style={styles.tableCell}>{i + 1}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                            <div style={styles.summaryCards}>
                                <div style={{...styles.summaryCard, borderRightColor: '#11cdef'}}>
                                    <div style={{...styles.summaryIconBg, background: '#11cdef'}}>
                                        <ReceiptIcon style={{ fontSize: '2rem', color: '#11cdef' }} />
                                    </div>
                                    <div style={styles.summaryContent}>
                                        <div style={styles.summaryLabel}>العدد الكلي</div>
                                        <div style={{...styles.summaryValue, color: '#11cdef'}}>
                                            {all_count}
                                        </div>
                                    </div>
                                </div>
                                <div style={{...styles.summaryCard, borderRightColor: '#2dce89'}}>
                                    <div style={{...styles.summaryIconBg, background: '#2dce89'}}>
                                        <CheckCircleIcon style={{ fontSize: '2rem', color: '#2dce89' }} />
                                    </div>
                                    <div style={styles.summaryContent}>
                                        <div style={styles.summaryLabel}>تم فحصها</div>
                                        <div style={{...styles.summaryValue, color: '#2dce89'}}>
                                            {done_count}
                                        </div>
                                    </div>
                                </div>
                                <div style={{...styles.summaryCard, borderRightColor: '#ffc107'}}>
                                    <div style={{...styles.summaryIconBg, background: '#ffc107'}}>
                                        <HourglassEmptyIcon style={{ fontSize: '2rem', color: '#ffc107' }} />
                                    </div>
                                    <div style={styles.summaryContent}>
                                        <div style={styles.summaryLabel}>القطع المتبقية</div>
                                        <div style={{...styles.summaryValue, color: '#ffc107'}}>
                                            {all_count - done_count}
                                        </div>
                                    </div>
                                </div>
                                <div style={{...styles.summaryCard, borderRightColor: '#5e72e4'}}>
                                    <div style={{...styles.summaryIconBg, background: '#5e72e4'}}>
                                        <AttachMoneyIcon style={{ fontSize: '2rem', color: '#5e72e4' }} />
                                    </div>
                                    <div style={styles.summaryContent}>
                                        <div style={styles.summaryLabel}>المبلغ الكلي</div>
                                        <div style={{...styles.summaryValue, color: '#5e72e4'}}>
                                            {(this.state.t_price + this.state.shipping).toLocaleString()}
                                        </div>
                                    </div>
                                </div>
                                <div style={{...styles.summaryCard, borderRightColor: '#2dce89'}}>
                                    <div style={{...styles.summaryIconBg, background: '#2dce89'}}>
                                        <CheckCircleIcon style={{ fontSize: '2rem', color: '#2dce89' }} />
                                    </div>
                                    <div style={styles.summaryContent}>
                                        <div style={styles.summaryLabel}>المبلغ المدفوع</div>
                                        <div style={{...styles.summaryValue, color: '#2dce89'}}>
                                            {this.state.paid_amount.toLocaleString()}
                                        </div>
                                    </div>
                                </div>
                                <div style={{...styles.summaryCard, borderRightColor: '#fb6340'}}>
                                    <div style={{...styles.summaryIconBg, background: '#fb6340'}}>
                                        <HourglassEmptyIcon style={{ fontSize: '2rem', color: '#fb6340' }} />
                                    </div>
                                    <div style={styles.summaryContent}>
                                        <div style={styles.summaryLabel}>المبلغ المتبقي</div>
                                        <div style={{...styles.summaryValue, color: '#fb6340'}}>
                                            {this.state.r_amount.toLocaleString()}
                                        </div>
                                    </div>
                                </div>
                                <div style={{...styles.summaryCard, borderRightColor: '#f5365c'}}>
                                    <div style={{...styles.summaryIconBg, background: '#f5365c'}}>
                                        <LocalShippingIcon style={{ fontSize: '2rem', color: '#f5365c' }} />
                                    </div>
                                    <div style={styles.summaryContent}>
                                        <div style={styles.summaryLabel}>مصاريف أخرى</div>
                                        <div style={{...styles.summaryValue, color: '#f5365c'}}>
                                            {this.state.shipping.toLocaleString()}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {(this.state.is_transfer == 1 || (this.state.status == 2 && this.state.safeCheck == 1) || this.state.status == 1) && (
                                <div style={{ marginTop: '2rem' }}>
                                    {this.state.is_transfer == 1 && (
                                        <div style={styles.checkboxContainer}>
                                            <CheckCircleIcon style={{ color: '#2dce89', fontSize: '1.5rem' }} />
                                            <span style={{ fontWeight: '600' }}>تم الدفع بواسطة حوالة</span>
                                        </div>
                                    )}
                                    {this.state.status == 2 && this.state.safeCheck == 1 && (
                                        <div style={styles.checkboxContainer}>
                                            <CheckCircleIcon style={{ color: '#2dce89', fontSize: '1.5rem' }} />
                                            <span style={{ fontWeight: '600' }}>تم دفع مصاريف الشحن عند الاستلام فقط</span>
                                        </div>
                                    )}
                                    {this.state.status == 1 && (
                                        <div style={styles.checkboxContainer}>
                                            <Form.Check
                                                type={"checkbox"}
                                                label={`اخراج مصاريف الشحن من القصة`}
                                                id={`safeOut`}
                                                style={{ marginBottom: 0 }}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div style={styles.actionButtons}>
                            <Component initialState={{ isShown: false, isConfirmLoading: false }}>
                                {({ state, setState }) => (
                                    <Pane>
                                        <Dialog
                                            isShown={state.isShown}
                                            title='قبول القائمة'
                                            onCloseComplete={() => setState({ isShown: false })}
                                            confirmLabel="اضافة"
                                            cancelLabel="الغاء"
                                            isConfirmLoading={state.isConfirmLoading}
                                            onConfirm={() => {
                                                setState({ isConfirmLoading: true })
                                                this.get_inv(this.state.Getid)
                                            }}
                                        >
                                            <div>
                                                <center>
                                                    <Alert variant={"danger"}>
                                                        هل تريد فعلاً ادخال هذه القائمة المخزن؟
                                                    </Alert>
                                                </center>
                                            </div>
                                        </Dialog>

                                        <button
                                            style={this.state.status == 1 ? 
                                                {...styles.actionButton, ...styles.primaryButton} : 
                                                { display: 'none' }} 
                                            onClick={() => setState({ isShown: true })}
                                        >
                                            <StoreIcon style={{ marginRight: '0.5rem', fontSize: '1.2rem' }} />
                                            ادخال الى المخزن
                                        </button>
                                    </Pane>
                                )}
                            </Component>

                            <button
                                style={this.state.status == 0 && role == -1 ? 
                                    {...styles.actionButton, ...styles.successButton} : 
                                    { display: 'none' }} 
                                onClick={() => this.chage_status(1)}
                            >
                                <CheckCircleIcon style={{ marginRight: '0.5rem', fontSize: '1.2rem' }} />
                                قبول
                            </button>

                            <button
                                style={this.state.status == 0 && role == -1 ? 
                                    {...styles.actionButton, ...styles.dangerButton} : 
                                    { display: 'none' }} 
                                onClick={() => this.chage_status(3)}
                            >
                                <CancelIcon style={{ marginRight: '0.5rem', fontSize: '1.2rem' }} />
                                رفض
                            </button>
                        </div>

                        {this.state.status == 2 && (
                            <div style={styles.statsSection}>
                                <div style={styles.statsHeader}>
                                    <h2 style={styles.statsTitle}>تقارير القائمة</h2>
                                    <p style={styles.statsSubtitle}>احصائيات وتفاصيل الفحص</p>
                                </div>

                                <div style={styles.statsGrid}>
                                    <div style={{...styles.statCard, borderColor: '#5e72e4'}}>
                                        <div style={{
                                            ...styles.statIconWrapper,
                                            background: 'linear-gradient(135deg, #5e72e4 0%, #825ee4 100%)',
                                            boxShadow: '0 10px 30px rgba(94, 114, 228, 0.3)'
                                        }}>
                                            <AttachMoneyIcon style={styles.statIcon} />
                                        </div>
                                        <h4 style={styles.statLabel}>تكلفة قطع الغيار</h4>
                                        <div style={{...styles.statValue, color: '#5e72e4'}}>
                                            {this.state.parts_cost.toLocaleString()} 
                                            <span style={styles.statUnit}> دينار</span>
                                        </div>
                                        <div style={{
                                            ...styles.statChange,
                                            background: 'rgba(94, 114, 228, 0.1)',
                                            color: '#5e72e4'
                                        }}>
                                            التكلفة الإجمالية للصيانة
                                        </div>
                                    </div>

                                    <div style={{...styles.statCard, borderColor: '#2dce89'}}>
                                        <div style={{
                                            ...styles.statIconWrapper,
                                            background: 'linear-gradient(135deg, #2dce89 0%, #11cdef 100%)',
                                            boxShadow: '0 10px 30px rgba(45, 206, 137, 0.3)'
                                        }}>
                                            <BatteryChargingFullIcon style={styles.statIcon} />
                                        </div>
                                        <h4 style={styles.statLabel}>معدل البطاريات</h4>
                                        <div style={{...styles.statValue, color: '#2dce89'}}>
                                            {this.state.battery_avg.toFixed(0)}
                                            <span style={styles.statUnit}>%</span>
                                        </div>
                                        <div style={{
                                            ...styles.statChange,
                                            background: 'rgba(45, 206, 137, 0.1)',
                                            color: '#2dce89'
                                        }}>
                                            متوسط صحة البطاريات
                                        </div>
                                    </div>

                                    <div style={{...styles.statCard, borderColor: '#f5365c'}}>
                                        <div style={{
                                            ...styles.statIconWrapper,
                                            background: 'linear-gradient(135deg, #f5365c 0%, #f56036 100%)',
                                            boxShadow: '0 10px 30px rgba(245, 54, 92, 0.3)'
                                        }}>
                                            <SpeedIcon style={styles.statIcon} />
                                        </div>
                                        <h4 style={styles.statLabel}>عدد التخطي</h4>
                                        <div style={{...styles.statValue, color: '#f5365c'}}>
                                            {this.state.paybass}
                                            <span style={styles.statUnit}> جهاز</span>
                                        </div>
                                        <div style={{
                                            ...styles.statChange,
                                            background: 'rgba(245, 54, 92, 0.1)',
                                            color: '#f5365c'
                                        }}>
                                            أجهزة تم تخطيها
                                        </div>
                                    </div>

                                    <div style={{...styles.statCard, borderColor: '#11cdef'}}>
                                        <div style={{
                                            ...styles.statIconWrapper,
                                            background: 'linear-gradient(135deg, #11cdef 0%, #1171ef 100%)',
                                            boxShadow: '0 10px 30px rgba(17, 205, 239, 0.3)'
                                        }}>
                                            <BuildIcon style={styles.statIcon} />
                                        </div>
                                        <h4 style={styles.statLabel}>تكلفة السوفت</h4>
                                        <div style={{...styles.statValue, color: '#11cdef'}}>
                                            {this.state.softCost.toLocaleString()}
                                            <span style={styles.statUnit}> دينار</span>
                                        </div>
                                        <div style={{
                                            ...styles.statChange,
                                            background: 'rgba(17, 205, 239, 0.1)',
                                            color: '#11cdef'
                                        }}>
                                            تكلفة البرمجيات
                                        </div>
                                    </div>
                                </div>

                                <div style={{...styles.tableSection, marginTop: '2rem'}}>
                                    <h3 style={{ textAlign: 'center', marginBottom: '2rem', color: '#32325d', fontSize: '1.8rem', direction: 'rtl' }}>
                                        تفاصيل الأجهزة المفحوصة
                                    </h3>
                                    <MuiThemeProvider theme={this.getMuiTheme()}>
                                        <MaterialDatatable 
                                            data={this.state.items_sana} 
                                            columns={columns} 
                                            options={options} 
                                        />
                                    </MuiThemeProvider>
                                </div>
                            </div>
                        )}
                    </Container>
                </div>
            )
        } else {
            return (<Login />)
        }
    }
}

export default Category;